import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import moment from 'moment';
import { valueByName } from './form_utils';

const DatePickerWrapper = React.forwardRef(({ value, onChange, label, helperText, error, ...props }, ref) => {
  return (
    <DatePicker
      label={label}
      value={value ? moment(value) : null}
      onChange={newValue => {
        onChange(newValue && moment.isMoment(newValue) ? newValue.toISOString() : null);
      }}
      enableAccessibleFieldDOMStructure={false}
      slots={{
        textField: TextField,
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          margin: 'dense',
          variant: 'outlined',
          helperText: helperText,
          error: error,
        },
      }}
      disablePast
      format='D MMMM YYYY'
      ref={ref}
      {...props}
    />
  );
});

export const ECDateField = props => {
  const { name, label, form, defaultValue, initial, ...rest } = props;

  const dv = valueByName(initial, name) || defaultValue || moment().toISOString();

  return (
    <Controller
      control={form.control}
      name={name}
      defaultValue={moment(dv).isValid() ? moment(dv).toISOString() : null}
      render={({ field, fieldState }) => (
        <DatePickerWrapper
          {...field}
          label={label}
          helperText={fieldState.error?.message || (form.formState.errors[name] && form.formState.errors[name].message)}
          error={!!fieldState.error || !!form.formState.errors[name]}
          {...rest}
        />
      )}
    />
  );
};

ECDateField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  form: PropTypes.object,
  defaultValue: PropTypes.any,
  initial: PropTypes.object,
};
